// src/utils/generarPassword.js
// ============================================================================
// Genera una contraseña al azar para las cuentas del sistema.
//
// 🔴 La aleatoriedad sale de `crypto.getRandomValues` (el generador seguro del
// navegador), NUNCA de `Math.random()` — regla de SEGURIDAD_GUIA.md: `Math.random`
// es predecible y no sirve para nada que proteja una cuenta.
//
// El alfabeto deja afuera a propósito los caracteres que se confunden al leerlos
// o al dictarlos por teléfono: I, l, 1, O, o, 0. La contraseña se la pasa una
// persona a otra, y un cero que se lee como "o" termina en una llamada a soporte.
//
// La contraseña se genera SIEMPRE en el navegador del administrador y viaja al
// servidor por HTTPS; el servidor no la genera ni la devuelve (ver la Cloud
// Function `restablecerPasswordAdmin`).
//
// Lo usan: el botón "Nueva Pass" de un usuario existente
// (`bigQueryService.restablecerPasswordAdmin`) y el botón "Generar" del
// formulario de usuario nuevo (`GestionUsuarios`).
// ============================================================================

const CARACTERES = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789@#$%&*';

/**
 * @param {number} longitud  Cantidad de caracteres (12 por defecto).
 * @returns {string} La contraseña generada.
 */
export function generarPassword(longitud = 12) {
  const aleatorios = new Uint32Array(longitud);
  window.crypto.getRandomValues(aleatorios);
  let password = '';
  for (let i = 0; i < longitud; i++) {
    password += CARACTERES[aleatorios[i] % CARACTERES.length];
  }
  return password;
}

export default generarPassword;
